import React, { useEffect } from 'react';
import { fetchAPIDataWhileSettingState, roundDecimalNumber } from '../../b2b-common/helpers';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { fetchMeasurementUnit, fetchMeasurementUnitsData } from '../../../services/b2b-indicators-apiService';
import { Chip, Stack } from '@mui/material';

export const ConvertFromTable = ({ convertFromUnits, onSelectConversion = null }) => {
    const headers = [
        { label: 'Conversion Unit', align: 'left' },
        { label: 'Formula', align: 'center' },
        { label: 'x = 1', align: 'center' },
    ];

    const rows = convertFromUnits ? convertFromUnits.map((convertFromUnit) => ({
        id: convertFromUnit.to.quantitativeMeasurementUnitId,
        cells: [
            { content: `${convertFromUnit.to.quantitativeMeasurementUnitName_label}`, align: 'left' },
            { content: `${convertFromUnit.directConversionFormula}`, align: 'center' },
            { content: `${roundDecimalNumber(convertFromUnit.fromToConversionOf1, 5)} ${convertFromUnit.from.quantitativeMeasurementUnit}`, align: 'center' },
        ]
    })) : [];

    const handleSelectConversion = (selectedRow) => {
        console.log('convertFromUnits:', convertFromUnits);
        console.log('Selected row:', selectedRow);
        if (!onSelectConversion) return;
        const conversion = convertFromUnits.find((unit) => unit.to.quantitativeMeasurementUnitId === selectedRow);
        onSelectConversion(conversion);
    }

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={"convert-to-measurement-units-list-table"}
            numRows={5}
            stickyHeader={false}
            onRowClick={handleSelectConversion}
        />
    );
};

export const ConvertToTable = ({ convertToUnits, onSelectConversion = null }) => {
    const headers = [
        { label: 'Conversion Unit', align: 'left' },
        { label: 'Formula', align: 'center' },
        { label: 'x = 1', align: 'center' },
    ];

    const rows = convertToUnits ? convertToUnits.map((convertToUnit) => ({
        id: convertToUnit.from.quantitativeMeasurementUnitId,
        cells: [
            { content: `${convertToUnit.from.quantitativeMeasurementUnitName_label}`, align: 'left' },
            { content: `${convertToUnit.reversedConversionFormula}`, align: 'center' },
            { content: `${roundDecimalNumber(convertToUnit.toFromConversionOf1, 5)} ${convertToUnit.to.quantitativeMeasurementUnit}`, align: 'center' },
        ]
    })) : [];

    const handleSelectConversion = (selectedRow) => {
        // console.log('convertToUnits:', convertToUnits);
        // console.log('Selected row:', selectedRow);
        if (!onSelectConversion) return;
        const conversion = convertToUnits.find((unit) => unit.from.quantitativeMeasurementUnitId === selectedRow);
        onSelectConversion(conversion);
    }

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={"convert-from-measurement-units-list-table"}
            numRows={5}
            stickyHeader={false}
            onRowClick={handleSelectConversion}
        />
    );
};

export const CategoriesChips = ({ categories, onDeletedCategory }) => {

    const handleDelete = (category) => {
        //console.log('Deleting category:', category);
        onDeletedCategory(category);
    }
    // console.log('CategoriesChips:', categories);
    return (
        <Stack direction="row" spacing={1} className='categories-stack'>
            {categories && categories.length > 0 && categories.map((category) => (
                <Chip
                    key={category.measurementUnitCategoryId}
                    label={category.measurementUnitCategoryName}
                    variant="outlined" onDelete={() => handleDelete(category)}
                    className='category-chip'
                />
            ))}
        </Stack>
    );
};

// API helper functions

export const getMeasurementUnits = async (loginData, setMeasurementUnits, setError) => {
    try {
        const { accessToken } = loginData;
        const data = await fetchMeasurementUnitsData(accessToken);
        setMeasurementUnits(data);
    } catch (error) {
        console.error('Error getting measurement units:', error);
        setError(error.message);
    }
}

export const getMeasurementUnit = async (loginData, quantitativeMeasurementUnitId, setMeasurementUnit, setError) => {
    if (!quantitativeMeasurementUnitId || !loginData.accessToken) return;
    try {
        const qmu = await fetchAPIDataWhileSettingState(fetchMeasurementUnit, [quantitativeMeasurementUnitId, loginData.accessToken]);
        setMeasurementUnit(qmu);
    } catch (error) {
        console.error(error);
        setError(error.message);
    }
}
